import { ChangeDetectionStrategy, Component } from '@angular/core';

interface Sparkle {
  left: number;
  bottom: number;
  delay: number;
  duration: number;
  size: number;
  glyph: string;
  color: string;
}

/**
 * Diwali sparkles: small gold / orange glyphs that float up and fade out (the background of the sale countdown on the landing page).
 * Fills its parent (position: absolute) and ignores clicks, so put it behind the content: <ipm-diwali-sparkles></ipm-diwali-sparkles>
 * Positions and timing are fixed (css animation, no timers), so every render looks the same.
 */
@Component({
  selector: 'ipm-diwali-sparkles',
  templateUrl: './diwali-sparkles.component.html',
  styleUrls: ['./diwali-sparkles.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiwaliSparklesComponent {
  readonly sparkles: Array<Sparkle> = this.buildSparkles();

  trackByIndex(index: number): number {
    return index;
  }

  private buildSparkles(): Array<Sparkle> {
    const glyphs = ['✦', '✧', '◆', '◇', '✿', '❋', '⋆'];
    const colors = ['#F59E0B', '#F97316', '#FBBF24', '#FDE68A', 'rgba(165,192,255,.7)'];
    // deterministic pseudo-random values so the layout is the same on every render
    return Array.from({ length: 14 }, (_, i) => ({
      left: (i * 37 + 11) % 94,
      bottom: (i * 23 + 7) % 60,
      delay: (i * 0.45) % 5,
      duration: 3 + ((i * 7) % 20) / 10,
      size: 9 + ((i * 5) % 8),
      glyph: glyphs[i % glyphs.length],
      color: colors[i % colors.length],
    }));
  }
}
